// this is an autogenerated file from DesignSystem/ImageCard/Content/Content/Actions/LinkedDocuments/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_ImageCard_Content_Content_Actions_LinkedDocuments($image_id: uuid!) {
  images_image_document_links(
    where: {
      image_id: { _eq: $image_id }
      document: { deleted: { _eq: false } }
    }
  ) {
    id
    document {
      id
      name
      type
    }
  }
}

`